import { api } from "../utils/api";

const getTheme = async () => {
  const res = await api.get("Settings/theme");
  return res.data;
};

const getExternalInfo = async () => {
  const res = await api.get("Settings/getExternalInfo");
  return res.data;
};

const getForgotPassword = async () => {
  const res = await api.get("Settings/forgotPasswordLabel");
  return res.data;
};

export default {
  getTheme,
  getExternalInfo,
  getForgotPassword
};
